import React from 'react';
import { ListGroupHeading } from 'components/List';

export interface SelectGroupHeadingProps extends React.ComponentPropsWithRef<'div'> {
  /** Group header. Consider using Typography component to override default Typography.  */
  children: string | React.ReactNode;
}

/** Group header for SelectItem dropdown list. */
const SelectGroupHeading = React.forwardRef<HTMLElement, SelectGroupHeadingProps>((props: SelectGroupHeadingProps, ref) => {
  const {
    children,
    ...otherProps
  } = props;
  return (
    <ListGroupHeading
      ref={ref}
      {...otherProps}
    >
      {children}
    </ListGroupHeading>
  );
});

SelectGroupHeading.displayName = 'SelectGroupHeading';
export { SelectGroupHeading as default };
